var _path, _polygon, _linearGradient, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Roof(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "240px",
    height: "240px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#999",
    d: "M42,19h-7v-2c0-0.552,0.448-1,1-1h5c0.552,0,1,0.448,1,1V19z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#ccc",
    points: "42,29.597 35,24.958 35,18 42,18"
  })), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "KZXzMA1_54Q1u483qCbTfa",
    x1: 24,
    x2: 24,
    y1: 378.361,
    y2: 353.203,
    gradientTransform: "matrix(1 0 0 -1 0 390)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d43a02"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b9360c"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#KZXzMA1_54Q1u483qCbTfa)",
    d: "M47.424,32.009L25.516,12.575C25.083,12.192,24.542,12,24,12s-1.083,0.192-1.516,0.575 L0.576,32.009c-0.48,0.427-0.513,1.166-0.073,1.634l1.87,1.994c0.422,0.45,1.125,0.485,1.589,0.077L24,18.204l20.039,17.512 c0.463,0.407,1.167,0.374,1.589-0.077l1.87-1.994C47.937,33.175,47.904,32.436,47.424,32.009z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Roof);
export default __webpack_public_path__ + "static/media/icons8-roof.46e52436d5d8f31c19f8ae55c926a656.svg";
export { ForwardRef as ReactComponent };